
import React from 'react';
import { User, Code, Rocket, Heart } from 'lucide-react';
import {getCldImageUrl} from './../utils/cloudinary';


const About: React.FC<{ darkMode: boolean }> = ({ darkMode }) => {
  const stats = [
    { icon: <Code />, label: '5+ Years', sub: 'Experience' },
    { icon: <Rocket />, label: '10+', sub: 'Projects Done' },
    { icon: <Heart />, label: '99%', sub: 'Happy Clients' },
  ];

  return (
    <div className="py-10">
      <div className="flex items-center gap-3 mb-8">
        <User className="text-blue-600" />
        <h3 className="text-3xl font-bold">About Me</h3>
      </div>
      
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        <div className={`space-y-6 text-lg ${darkMode ? 'text-slate-400' : 'text-slate-600'}`}>
          <p>
            I am a passionate software engineer with a deep love for creating clean, efficient, and user-centric solutions. Over the last 5 years, I've worked across diverse industries, from digital marketing startups to large-scale enterprise platforms.
          </p>
          <p>
            My approach blends technical rigor with creative problem solving. Whether it's architecting a complex backend in Laravel or crafting a pixel-perfect frontend in Vue, I strive for excellence in every line of code.
          </p>
          <div className="grid grid-cols-3 gap-4 pt-4">
            {stats.map((stat, idx) => (
              <div key={idx} className={`bg-slate-50 ${darkMode ? 'dark:bg-slate-900' : ''} p-4 rounded-2xl text-center border border-slate-200 dark:border-slate-800`}>
                <div className="text-blue-500 flex justify-center mb-2">{stat.icon}</div>
                <div className={`font-bold ${darkMode ? 'text-white' : 'text-slate-900'} text-xl`}>{stat.label}</div>
                <div className="text-sm">{stat.sub}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="relative group">
          <div className="absolute -inset-1 bg-gradient-to-r from-blue-600 to-indigo-500 rounded-3xl blur opacity-25 group-hover:opacity-50 transition duration-1000"></div>
          <div className="relative bg-white dark:bg-slate-950 p-6 rounded-3xl border border-slate-200 dark:border-slate-800">
             <img 
              src={getCldImageUrl('viber_image_2026-02-04_09-04-02-620_xn4w4s')} 
              alt="Coding Workspace" 
              className="rounded-2xl w-full h-auto grayscale group-hover:grayscale-0 transition-all duration-700"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
